import React from "react";
import { Typography } from "@mui/material";

function Saannot(props) {
	return (
		<>
			<Typography variant="h2">Mini Miljoona Pilkki säännöt</Typography>

			<Typography>
				Suuren suosion saavuttanut Mini Miljoona Pilkki on Kyläkaupan
				järjestämä ilmainen kalastuskilpailu kaikille ala-astelaisille.
				Tänä vuonna se järjestetään jo viidettä kertaa. Ilmaisen,
				henkilökohtaisen osallistumisoikeuden kilpailuun saa noutaa
				veloituksetta Kyläkaupan Neuvonnasta.
			</Typography>

			<Typography variant="h4">
				Yli miljoonan sentin palkintomahdollisuudet
			</Typography>

			<Typography>
				Kilpailusarjoja on kolme: ala-asteen 1-2 -luokkalaiset, 3-4
				-luokkalaiset ja 5-6 -luokkalaiset. Tapahtumaa seuraamaan ovat
				kaikki tervetulleita. Palkintomahdollisuuksien yhteisarvo on yli
				miljoonan – tällä kertaa yli miljoona senttiä. Summa koostuu
				sadasta lottopottilohesta, joissa on sadan euron
				Kyläkauppa-ostokorttiin oikeuttava merkki. Näiden kirjolohien
				lisäksi kaikkien kolmen sarjan kolme parasta palkitaan
				Kyläkaupan ostokorteilla seuraavasti: 100 euroa, 50 euroa ja 30
				euroa. Kilpailulampeen, joka on kooltaan noin 100 metriä kertaa
				300 metriä, on syksyllä istutettu kirjolohia yli tuhat kiloa.
				Merkittyjen kirjolohien lisäksi jään alla uiskentelee siis
				runsaasti myös merkitsemättömiä kirjolohia, joista voi loihtia
				kotona herkkuateria. Palkintojen lisäksi Kyläkauppa tarjoaa
				jokaiselle kilpailijalle hampurilaisaterian OnnenKivi-ravintolan
				grillissä.
			</Typography>

			<Typography variant="h4">
				Selkeät ja oikeudenmukaiset säännöt
			</Typography>

			<Typography>
				Mini Miljoona Pilkki on ala-astelaisten kalastuskilpailu.
				Avustajia saa olla yksi, mutta tukijoukon kokoa ei rajata.
				Avustaja saa auttaa reiän kairaamisessa, syötin asettamisessa,
				siiman selvittämisessä, vieheenvaihtamisessa, ohjeistamisessa
				jne. Avustajalla ei ole oikeutta koskea pilkkivapaan tai
				siimaan, kun viehe on vedessä. Se johtaa kilpailijan välittömään
				diskaukseen. Nostokoukun käyttö ilman pilkkivapaan ja siimaan
				tarttumista on myös avustajalle sallittu. Eli avustajan merkitys
				on tärkeä.
			</Typography>
			<Typography variant="h4">
				Tunnin kilpailuaika tekee tapahtumasta jännittävän
			</Typography>

			<Typography>
				Kilpailuaika on rajattu tuntiin, koska tapahtuman on haluttu
				olevan aktiivinen ja innostava. Kilpailu alkaa klo 12.00 ja
				päättyy klo 13.00. Punnitsemisen jälkeen on hyvää aikaa ajella
				ostoksille ja ruokailemaan. Siirtymäaika kilpailupaikalta
				Kyläkaupalle on vain noin 30 minuuttia.
			</Typography>
		</>
	);
}

export default Saannot;
